{
  "base": {
    "article": "artikeln",
    "flash": "flashen",
    "timeless": "tidlös",
    "draft": {
      "title": "Utkast",
      "description": "Du jobbar på ett utkast av {{label}}",
      "transitions": {
        "done": {
          "title": "Klarmarkera",
          "description": "Markera {{label}} som klar",
          "promptTitle": "Klarmarkera {{label}}"
        },
        "approved": {
          "title": "Godkänn",
          "description": "Godkänn {{label}} för publicering",
          "promptTitle": "Godkänn {{label}}"
        },
        "usable": {
          "title": "Publicera",
          "description": "Publicera {{label}}",
          "promptTitle": "Publicera {{label}}"
        },
        "withheld": {
          "title": "Schemalägg publicering",
          "description": "Ange tid för publicering. Flytta uppdrag/planering om annat datum önskas.",
          "promptTitle": "Schemalägg publicering av {{label}}"
        }
      }
    },
    "done": {
      "title": "Klar",
      "description": "{{label, capitalize}} är klar och väntar på godkännande",
      "transitions": {
        "approved": {
          "title": "Godkänn",
          "description": "Godkänn {{label}} för publicering",
          "promptTitle": "Godkänn {{label}}"
        },
        "usable": {
          "title": "Publicera",
          "description": "Publicera {{label}} direkt",
          "promptTitle": "Publicera {{label}}"
        },
        "withheld": {
          "title": "Schemalägg publicering",
          "description": "Ange tid för publicering. Flytta uppdrag/planering om annat datum önskas.",
          "promptTitle": "Schemalägg publicering av {{label}}"
        },
        "draft": {
          "title": "Till utkast",
          "description": "Gör om {{label}} till ett utkast igen",
          "promptTitle": "Gör om {{label}} till ett utkast"
        },
        "unpublished": {
          "title": "Avpublicera",
          "description": "Avbryt och arkivera {{label}}",
          "promptTitle": "Avpublicera {{label}}"
        }
      }
    },
    "approved": {
      "title": "Godkänd",
      "description": "{{label, capitalize}} är godkänd att publicera",
      "transitions": {
        "usable": {
          "title": "Publicera",
          "description": "Publicera {{label}}",
          "promptTitle": "Publicera {{label}}"
        },
        "withheld": {
          "title": "Schemalägg publicering",
          "description": "Ange tid för publicering. Flytta uppdrag/planering om annat datum önskas.",
          "promptTitle": "Schemalägg publicering av {{label}}"
        },
        "draft": {
          "title": "Till utkast",
          "description": "Gör om {{label}} till ett utkast igen",
          "promptTitle": "Gör om {{label}} till ett utkast"
        },
        "unpublished": {
          "title": "Avpublicera",
          "description": "Avbryt och arkivera {{label}}",
          "promptTitle": "Avpublicera {{label}}"
        }
      }
    },
    "usable": {
      "title": "Publicerad",
      "description": "{{label, capitalize}} är publicerad",
      "transitions": {
        "draft": {
          "title": "Ny version",
          "description": "Fortsätt jobba på en ny version av {{label}}",
          "promptTitle": "Skapa ny version av {{label}}"
        },
        "unpublished": {
          "title": "Avpublicera",
          "description": "Avbryt publiceringen och arkivera {{label}}",
          "promptTitle": "Avpublicera {{label}}"
        }
      }
    },
    "withheld": {
      "title": "Schemalagd",
      "description": "{{label, capitalize}} är schemalagd för automatisk publicering",
      "transitions": {
        "usable": {
          "title": "Publicera direkt",
          "description": "Publicera {{label}} direkt",
          "promptTitle": "Publicera {{label}} direkt"
        },
        "draft": {
          "title": "Till utkast",
          "description": "Avbryt schemalagd publicering och gör om till utkast igen",
          "promptTitle": "Gör om {{label}} till utkast"
        }
      }
    },
    "unpublished": {
      "title": "Avpublicerad",
      "description": "{{label, capitalize}} har avpublicerats",
      "transitions": {
        "draft": {
          "title": "Ny version",
          "description": "Fortsätt jobba på en ny version av {{label}}",
          "promptTitle": "Skapa ny version av {{label}}"
        }
      }
    },
    "used": {
      "title": "Använd",
      "description": "{{label, capitalize}} har använts för att skapa ett nytt dokument",
      "transitions": {
        "draft": {
          "title": "Öppna som utkast",
          "description": "Återställ {{label}} till utkast för vidare redigering"
        }
      }
    }
  },
  "core/event": {
    "draft": {
      "title": "Utkast",
      "description": "Du jobbar på ett utkast av denna händelse",
      "transitions": {
        "done": {
          "title": "Använd internt",
          "description": "Gör händelsen internt synlig"
        },
        "usable": {
          "title": "Publicera externt",
          "description": "Publicera händelsen externt",
          "promptTitle": "Publicera händelsen externt"
        }
      }
    },
    "done": {
      "title": "Intern",
      "description": "Händelsen är internt synlig",
      "transitions": {
        "usable": {
          "title": "Publicera",
          "description": "Publicera händelsen externt",
          "promptTitle": "Publicera händelsen"
        },
        "unpublished": {
          "title": "Avpublicera",
          "description": "Avpublicera händelsen",
          "promptTitle": "Avpublicera händelsen"
        }
      }
    },
    "usable": {
      "title": "Publicerad",
      "asSaveCTA": "Opublicerade ändringar",
      "asSaveTitle": "Publicera ny version",
      "description": "Händelsen är publicerad externt",
      "changedDescription": "Händelsen har ändrats sedan den senaste publiceringen",
      "updateDescription": "Uppdatera den publicerade händelsen med de nya ändringarna",
      "transitions": {
        "unpublished": {
          "title": "Avpublicera",
          "description": "Avpublicera händelsen externt",
          "promptTitle": "Avpublicera händelsen"
        }
      }
    },
    "unpublished": {
      "title": "Avpublicerad",
      "description": "Händelsen har avpublicerats",
      "transitions": {
        "draft": {
          "title": "Utkast",
          "description": "Gör om händelsen till ett utkast igen",
          "promptTitle": "Gör om händelsen till ett utkast"
        }
      }
    }
  },
  "core/planning-item": {
    "draft": {
      "title": "Utkast",
      "description": "Du jobbar på ett utkast av denna planering",
      "transitions": {
        "done": {
          "title": "Använd internt",
          "description": "Gör planeringen internt synlig"
        },
        "usable": {
          "title": "Publicera externt",
          "description": "Publicera planeringen externt",
          "promptTitle": "Publicera planeringen externt"
        }
      }
    },
    "done": {
      "title": "Intern",
      "description": "Planeringen är internt synlig",
      "transitions": {
        "usable": {
          "title": "Publicera",
          "promptTitle": "Publicera planeringen",
          "description": "Publicera planeringen externt"
        },
        "unpublished": {
          "title": "Avpublicera",
          "promptTitle": "Avpublicera planeringen",
          "description": "Avpublicera planeringen"
        }
      }
    },
    "usable": {
      "title": "Publicerad",
      "asSaveCTA": "Opublicerade ändringar",
      "asSaveTitle": "Publicera ändrad version",
      "description": "Planeringen är publicerad",
      "changedDescription": "Planeringen har ändrats sedan den senaste publiceringen",
      "updateDescription": "Uppdatera den publicerade planeringen med de nya ändringarna",
      "transitions": {
        "unpublished": {
          "title": "Avpublicera",
          "description": "Avpublicera planeringen externt",
          "promptTitle": "Avpublicera planeringen"
        }
      }
    },
    "unpublished": {
      "title": "Avpublicerad",
      "description": "Planeringen har avpublicerats",
      "transitions": {
        "draft": {
          "title": "Utkast",
          "promptTitle": "Gör om planeringen till ett utkast",
          "description": "Gör om planeringen till ett utkast igen"
        }
      }
    }
  },
  "core/factbox": {
    "draft": {
      "title": "Utkast",
      "description": "Du jobbar på ett utkast av faktarutan",
      "transitions": {
        "usable": {
          "verify": false,
          "title": "Klarmarkera",
          "description": "Klarmarkera faktarutan för användning"
        },
        "unpublished": {
          "verify": false,
          "title": "Kasta",
          "description": "Ta bort faktarutan"
        }
      }
    },
    "usable": {
      "title": "Klar",
      "asSaveCTA": "Ändrad",
      "asSaveTitle": "Uppdatera",
      "description": "Faktarutan är klar",
      "updateDescription": "Klarmarkera ändringarna",
      "transitions": {
        "draft": {
          "title": "Till utkast",
          "description": "Gör om faktarutan till ett utkast igen"
        },
        "unpublished": {
          "verify": false,
          "title": "Kasta",
          "description": "Ta bort faktarutan"
        }
      }
    },
    "unpublished": {
      "title": "Kastad",
      "description": "Faktarutan är inte synlig eller användbar",
      "isWorkflow": false,
      "transitions": {
        "usable": {
          "verify": false,
          "title": "Klarmarkera",
          "description": "Klarmarkera faktarutan för användning"
        }
      }
    }
  },
  "core/editorial-info": {
    "draft": {
      "title": "Utkast",
      "description": "Du jobbar på ett utkast av detta till red",
      "transitions": {
        "done": {
          "title": "Klarmarkera",
          "description": "Markera till red som klar",
          "promptTitle": "Klarmarkera till red"
        },
        "approved": {
          "title": "Godkänn",
          "description": "Godkänn till red för intern användning",
          "promptTitle": "Godkänn till red"
        },
        "usable": {
          "title": "Publicera",
          "description": "Publicera till red externt synlig",
          "promptTitle": "Publicera till red"
        }
      }
    },
    "done": {
      "title": "Klar",
      "description": "Till red är klar och väntar på godkännande",
      "transitions": {
        "approved": {
          "title": "Godkänn",
          "description": "Godkänn till red för intern användning",
          "promptTitle": "Godkänn till red"
        },
        "usable": {
          "title": "Publicera",
          "description": "Publicera till red externt synlig",
          "promptTitle": "Publicera till red"
        },
        "draft": {
          "title": "Till utkast",
          "description": "Gör om till red till ett utkast igen",
          "promptTitle": "Gör om till red till ett utkast"
        }
      }
    },
    "approved": {
      "title": "Intern",
      "description": "Till red är internt publicerad och går att publicera externt",
      "transitions": {
        "usable": {
          "title": "Publicera",
          "description": "Publicera till red externt synlig",
          "promptTitle": "Publicera till red"
        },
        "draft": {
          "title": "Till utkast",
          "description": "Gör om till red till ett utkast igen",
          "promptTitle": "Gör om till red till ett utkast"
        }
      }
    },
    "usable": {
      "title": "Publicerad",
      "description": "Till red är publicerad",
      "transitions": {
        "draft": {
          "title": "Till utkast",
          "description": "Gör om till red till ett utkast igen",
          "promptTitle": "Gör om till red till ett utkast"
        },
        "unpublished": {
          "title": "Dra tillbaka",
          "description": "Avbryt publiceringen och arkivera till red",
          "promptTitle": "Dra tillbaka till red"
        }
      }
    }
  },
  "tt/print-article": {
    "draft": {
      "title": "Utkast",
      "description": "Du jobbar på ett utkast av printartikeln",
      "transitions": {
        "needs_proofreading": {
          "title": "Begär korrläsning",
          "description": "Behöver korrläsning av printartikeln",
          "promptTitle": "Begär korrläsning av printartikeln"
        },
        "print_done": {
          "title": "Klarmarkera",
          "description": "Markera printartikeln som klar",
          "promptTitle": "Klarmarkera printartikeln"
        },
        "usable": {
          "title": "Exportera",
          "description": "Exportera printartikeln",
          "promptTitle": "Exportera printartikeln"
        }
      }
    },
    "needs_proofreading": {
      "title": "Klar för korr",
      "description": "Printartikeln behöver korrläsning",
      "transitions": {
        "print_done": {
          "title": "Klarmarkera",
          "description": "Markera printartikeln som klar",
          "promptTitle": "Klarmarkera printartikeln"
        },
        "usable": {
          "title": "Exportera",
          "description": "Exportera printartikeln",
          "promptTitle": "Exportera printartikeln"
        },
        "cancelled": {
          "title": "Kasta",
          "description": "Kasta printartikeln",
          "promptTitle": "Kasta printartikeln"
        },
        "draft": {
          "title": "Till utkast",
          "description": "Gör om printartikeln till ett utkast igen",
          "promptTitle": "Gör om printartikeln till ett utkast"
        }
      }
    },
    "print_done": {
      "title": "Klar",
      "description": "Printartikeln är klar och väntar på godkännande",
      "transitions": {
        "approved": {
          "title": "Godkänn",
          "description": "Godkänn printartikeln",
          "promptTitle": "Godkänn printartikeln"
        },
        "usable": {
          "title": "Exportera",
          "description": "Exportera printartikeln",
          "promptTitle": "Exportera printartikeln"
        },
        "needs_proofreading": {
          "title": "Begär korrläsning",
          "description": "Behöver korrläsning av printartikeln",
          "promptTitle": "Begär korrläsning av printartikeln"
        },
        "cancelled": {
          "title": "Kasta",
          "description": "Kasta printartikeln",
          "promptTitle": "Kasta printartikeln"
        },
        "draft": {
          "title": "Till utkast",
          "description": "Gör om printartikeln till ett utkast igen",
          "promptTitle": "Gör om printartikeln till ett utkast"
        }
      }
    },
    "usable": {
      "title": "Exporterad",
      "asSaveCTA": "Oexporterade ändringar",
      "asSaveTitle": "Exportera ändrad version",
      "description": "Printartikeln är exporterad",
      "changedDescription": "Printartikeln har ändrats sedan den senaste exporten",
      "updateDescription": "Uppdatera den exporterade printartikeln med de nya ändringarna",
      "transitions": {
        "unpublished": {
          "title": "Dra tillbaka",
          "description": "Avbryt export och arkivera printartikeln",
          "promptTitle": "Dra tillbaka printartikeln"
        }
      }
    },
    "unpublished": {
      "title": "Inställd",
      "description": "Printartikeln är avpublicerad",
      "transitions": {
        "draft": {
          "title": "Till utkast",
          "description": "Gör om printartikeln till ett utkast igen",
          "promptTitle": "Gör om printartikeln till ett utkast"
        }
      }
    },
    "cancelled": {
      "title": "Kastad",
      "description": "Printartikeln är kastad",
      "transitions": {
        "draft": {
          "title": "Till utkast",
          "description": "Gör om printartikeln till ett utkast igen",
          "promptTitle": "Gör om printartikeln till ett utkast"
        }
      }
    }
  },
  "core/article#timeless": {
    "article": "artikeln",
    "flash": "flashen",
    "draft": {
      "title": "Utkast",
      "description": "Du jobbar på ett utkast av {{label}}",
      "transitions": {
        "done": {
          "title": "Klarmarkera",
          "description": "Markera {{label}} som klar"
        },
        "approved": {
          "title": "Godkänn",
          "description": "Godkänn {{label}} för publicering"
        },
        "usable": {
          "title": "Publicera",
          "description": "Publicera {{label}}"
        },
        "withheld": {
          "title": "Schemalägg publicering",
          "description": "Ange tid för publicering. Flytta uppdrag/planering om annat datum önskas."
        }
      }
    },
    "done": {
      "title": "Klar",
      "description": "{{label, capitalize}} är klar och väntar på godkännande",
      "transitions": {
        "approved": {
          "title": "Godkänn",
          "description": "Godkänn {{label}} för publicering"
        },
        "usable": {
          "title": "Publicera",
          "description": "Publicera {{label}} direkt"
        },
        "withheld": {
          "title": "Schemalägg publicering",
          "description": "Ange tid för publicering. Flytta uppdrag/planering om annat datum önskas."
        },
        "draft": {
          "title": "Till utkast",
          "description": "Gör om {{label}} till ett utkast igen"
        },
        "unpublished": {
          "title": "Avpublicera",
          "description": "Avbryt och arkivera {{label}}"
        }
      }
    },
    "approved": {
      "title": "Godkänd",
      "description": "{{label, capitalize}} är godkänd att publicera",
      "transitions": {
        "usable": {
          "title": "Publicera",
          "description": "Publicera {{label}}"
        },
        "withheld": {
          "title": "Schemalägg publicering",
          "description": "Ange tid för publicering. Flytta uppdrag/planering om annat datum önskas."
        },
        "draft": {
          "title": "Till utkast",
          "description": "Gör om {{label}} till ett utkast igen"
        },
        "unpublished": {
          "title": "Avpublicera",
          "description": "Avbryt och arkivera {{label}}"
        }
      }
    },
    "usable": {
      "title": "Publicerad",
      "description": "{{label, capitalize}} är publicerad",
      "transitions": {
        "draft": {
          "title": "Ny version",
          "description": "Fortsätt jobba på en ny version av {{label}}"
        },
        "unpublished": {
          "title": "Avpublicera",
          "description": "Avbryt publiceringen och arkivera {{label}}"
        }
      }
    },
    "withheld": {
      "title": "Schemalagd",
      "description": "{{label, capitalize}} är schemalagd för automatisk publicering",
      "transitions": {
        "usable": {
          "title": "Publicera direkt",
          "description": "Publicera {{label}} direkt"
        },
        "draft": {
          "title": "Till utkast",
          "description": "Avbryt schemalagd publicering och gör om till utkast igen"
        }
      }
    },
    "unpublished": {
      "title": "Avpublicerad",
      "description": "{{label, capitalize}} har avpublicerats",
      "transitions": {
        "draft": {
          "title": "Ny version",
          "description": "Fortsätt jobba på en ny version av {{label}}"
        }
      }
    }
  }
}
